import React from 'react';
import $ from 'jquery';

class ComponentToggleButton extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    let checkboxText;

    checkboxText = (this.props.buttonChecked ? this.props.buttonTextChecked : this.props.buttonTextNotChecked);

    return (
      <React.Fragment>
        <button className="component-toggle-button" tabIndex="0" aria-label={`Toggleknapp, ${checkboxText}`} toggle_selected={(this.props.buttonChecked ? 'True' : 'False')}  onClick={this.props.buttonClickedHandler}>
            <span className="toggleBefore" />
            <span className="toggleAfter" />
            <span className="toggleText">
                  {checkboxText}
            </span>
        </button>
      </React.Fragment>
    );
  }
}
export default ComponentToggleButton;
